/**
 * HeadlineMetric — huge amber numeral + eyebrow label + optional side metrics.
 * Used at the top of Family B (Tool / Metric+Table) pages.
 */
import React from 'react';

export const HeadlineMetric = ({
  label, value, valueSuffix, hint, sideMetrics = [], testId = 'headline-metric',
}) => (
  <div className="rounded-3xl bg-navy-spotlight text-background p-6 sm:p-8 relative overflow-hidden" data-testid={testId}>
    <div className="relative z-10 grid gap-6 md:grid-cols-3 md:items-end">
      <div className="md:col-span-2">
        {label && <span className="pill-badge">{label}</span>}
        <div className="mt-3 flex items-baseline gap-2">
          <span className="font-heading text-5xl sm:text-6xl font-extrabold tracking-tight text-primary leading-none">
            {value}
          </span>
          {valueSuffix && (
            <span className="text-xl font-semibold text-background/70">{valueSuffix}</span>
          )}
        </div>
        {hint && <p className="mt-2 text-sm text-background/70 max-w-md">{hint}</p>}
      </div>
      {sideMetrics.length > 0 && (
        <div className="grid grid-cols-2 gap-3 md:gap-4">
          {sideMetrics.map((m, i) => (
            <div key={i} className="rounded-2xl bg-background/5 border border-background/10 backdrop-blur-sm p-3 text-center" data-testid={`side-metric-${i}`}>
              <div className="text-[10px] uppercase tracking-widest text-background/60">{m.label}</div>
              <div className="mt-1 font-heading font-extrabold text-lg text-background">{m.value}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  </div>
);

export default HeadlineMetric;
